import { createApiAction, createPaginationAction, createInfoApiAction } from './common'

export const addDevice = createApiAction('addDevice')
export const getDeviceList = createPaginationAction('getDeviceList')
export const getDeviceInfo = createInfoApiAction('getDeviceInfo', id => ({ id }))
export const updateDeviceInfo = createInfoApiAction('updateDeviceInfo', (id, data) => ({ id, data }))
export const deleteDevice = createApiAction('deleteDevice')
